import { Volume } from '../types/content';
export var DEFAULT_CONTENT = {
    industryAncestry: ['9e0d43c23f82998a6ac269b5', '0e7f141a196bcc3bd9ed0670'],
    pages: [
        {
            // id: '1fe99a018486bb847d2d8fe5', TODO uncomment it
            name: 'Home',
            sections: [
                {
                    id: 'Welcome',
                    ceType: 'Welcome',
                    cardinality: 1,
                    header: {
                        prefix: '',
                        hidden: [],
                        labels: {},
                    },
                    footer: {
                        prefix: '',
                        hidden: [],
                        labels: {},
                    },
                    item: {
                        prefix: '',
                        hidden: [],
                        labels: {
                            longText: 'Description',
                        },
                    },
                    // dbId: '0cb352d003dfebe801b8a3ea', TODO uncomment it
                    syncWithBooking: 'none',
                    volume: Volume.BuiltIn,
                },
                {
                    id: 'About',
                    ceType: 'Homepage_about',
                    cardinality: 1,
                    header: {
                        prefix: '',
                        hidden: [],
                        labels: {},
                    },
                    footer: {
                        prefix: '',
                        hidden: [],
                        labels: {},
                    },
                    item: {
                        prefix: '',
                        hidden: [],
                        labels: {
                            longText: 'Description',
                        },
                    },
                    // dbId: '7d8e9fb29d64167e6762f2e0', TODO uncomment it
                    syncWithBooking: 'none',
                    volume: Volume.BuiltIn,
                },
            ],
            optional: false,
        },
    ],
    contentItems: [
        {
            industryIds: [],
            structureIds: ['e51e11f3597e0c565deb792f'],
            sectionIds: ['Welcome'],
            content: {
                title: ['{{GeneralDescription.BusinessName}}'],
                subTitle: ['Doing Business the Right Way'],
                longText: [
                    'Welcome to {{GeneralDescription.BusinessName}}. Our main goal is to always achieve a high level of customer satisfaction with the services and products that we provide. This simple approach has effectively fueled our growth since we opened our doors in {{GeneralDescription.YearFounded}}. We’re thrilled you’ve decided to visit us - please browse our site to discover what we’re all about.',
                ],
                button: ['Get in Touch'],
            },
            sets: [],
        },
        {
            industryIds: [],
            structureIds: ['e51e11f3597e0c565deb792f'],
            sectionIds: ['About'],
            content: {
                title: ['About Us'],
                subTitle: ['Our Background'],
                longText: [
                    'As one of the leading local businesses in the {{Contact.City}} area, we attribute our reputation to the lasting customer relationships we’ve developed throughout the years. We believe that all of our customers deserve the highest level of service, and we are committed to providing just that. Get in touch today to learn more.',
                ],
                button: ['Contact'],
            },
            sets: [],
        },
    ],
    kits: [
        '56ea6ad2688a379f00b7d1f1',
        '56a9cb909abbe1240060883c',
        '56dff911433b5a5b001fe394',
        '57021f5f0ac9962e00c8e5d4',
        '56e59effcc38532900200577',
        '579ef944a10db9520021b737',
        '5868d4eb6764341f00cac0c6',
        '56e57bfd917ec97a001e0f1a',
        '571cadb3ff1cf8f8009ba1e7',
        '585fb8e641d27e20005b9b63',
        '570267dce69a766d001fbb20',
        '585fac6a41d27e20005b9b5e',
        '56e6d6d18d7e8364002629da',
        '56e178c9aeeaf64900372cd6',
        '56e0514d203a352000f655b4',
        '56e03c0d40213a5700098eee',
        '56f8e5ff2479f32000bb279a',
        '56dd4d23a23c9120000cdae0',
        '56d45a44952a2d370028a4da',
        '56e52efbe394dda300b8519c',
        '56f7c38a0b19ae2e00eaab27',
        '56e7d6b101e8043700af8382',
        '56f3b343c9e0624900dfb8f1',
        '56e98ace8b6487fc00c58822',
        '56f801b45cd1577600f36112',
        '56e91b1c7471472e009ffa46',
        '5702657d8b893b91002cde69',
        '56dd4bc6ea63ca680027c89e',
        '56f93d103f30a72e0004f8d5',
        '56e80ad06c755b9a00887e26',
        '570243aca24ae92e00ad3204',
        '56f26ee2596068370028f88e',
        '56f9147e2479f32000bb279b',
        '56dff99f9a628e8800362dd4',
        '56e17e13f241a288009888d1',
        '56e52be07e8ffe5b00846e59',
        '570225f6e4b8ef9a00841798',
        '56a49c8dfb85744900a2b2b1',
        '57b05bd92560436d00544050',
        '57b07fc1b0ff73640098ce3e',
        '56e964357ab3fc3700a1197f',
        '584d5fbdc8e7512000dad50f',
        '5682a826a81c70310001c611',
        '5682ae70a81c70310001c64c',
        '5697e4d67bfbe94400385a70',
        '568297b6208c4c310054508b',
        '587b3a36c587ef1400686bc5',
        '587b7e7dc25b1014009cba44',
        '587b9783c587ef1400686bca',
        '587babe4c25b1014009cba49',
        '5869222c7f055d1f00e42a28',
    ],
    placeholders: [],
};
//# sourceMappingURL=defaultContentData.js.map